<div class="perfil-progress-section" role="progressbar" [attr.aria-valuenow]="progresoClamped" aria-valuemin="0"
  aria-valuemax="100" [attr.data-estado]="estado">
  <div class="perfil-progress-section__track">
    <div class="perfil-progress-section__fill" [style.width.%]="fillWidth"></div>
  </div>
  <div class="perfil-progress-section__markers" [attr.aria-hidden]="clickable ? null : true">
    @for (m of markers; track m) {
    @if (clickable) {
    <button type="button" class="perfil-progress-section__marker"
      [class.perfil-progress-section__marker--done]="isMarkerDone(m)"
      [class.perfil-progress-section__marker--current]="isMarkerCurrent(m)"
      [class.perfil-progress-section__marker--clickable]="true" [attr.aria-label]="'Paso ' + (m + 1)"
      (click)="onMarkerClick($event, m)"></button>
    } @else {
    <span class="perfil-progress-section__marker" [class.perfil-progress-section__marker--done]="isMarkerDone(m)"
      [class.perfil-progress-section__marker--current]="isMarkerCurrent(m)"></span>
    }
    }
  </div>
</div>
